import * as Types from "../constants/Role";

export const resetRole = () => ({
    type: Types.RESET_ROLE,
});

// ADD ROLES ACTIONS
export const addRole = (role) => ({
    type: Types.ADD_ROLE,
    payload: role
});

export const addRoleOk = () => ({
    type: Types.ADD_ROLE_OK,
})

export const addRoleFailed = (error) => ({
    type: Types.ADD_ROLE_FAILED,
    payload: error
})

// FETCH ROLES ACTIONS
export const fetchRoles = () => ({
    type: Types.FETCH_ROLES
});

export const fetchRolesOk = (roles) => ({
    type: Types.FETCH_ROLES_OK,
    payload: roles
})

export const fetchRolesFailed = (error) => ({
    type: Types.FETCH_ROLES_FAILED,
    payload: error
})

// FETCH MODULE ID ACTIONS
export const fetchRoleId = (id) => ({
    type: Types.FETCH_ROLE_ID,
    payload: id
});

export const fetchRoleIdOk = (role) => ({
    type: Types.FETCH_ROLE_ID_OK,
    payload: role
})

export const fetchRoleIdFailed = (error) => ({
    type: Types.FETCH_ROLE_ID_FAILED,
    payload: error
})

// PATCH MODULE ACTIONS
export const patchRole = ({ role, id }) => ({
    type: Types.PATCH_ROLE,
    payload: { role, id }
});

export const patchRoleOk = () => ({
    type: Types.PATCH_ROLE_OK,
})

export const patchRoleFailed = (error) => ({
    type: Types.PATCH_ROLE_FAILED,
    payload: error
})